const SOCIAL_LINKS = [
  {
    id: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/restingtachyon',
    icon: (
      <path
        d="M14 8.5h2.5V6H14c-2 0-3.5 1.5-3.5 3.5V12H8v2.5h2.5V21H13v-6.5h2.3L16 12h-3V9.5c0-.6.4-1 1-1z"
        fill="currentColor"
      />
    ),
  },
  {
    id: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/time__travelling/',
    icon: (
      <>
        <rect
          x="5"
          y="5"
          width="14"
          height="14"
          rx="4"
          ry="4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="16.5" cy="7.5" r="1" fill="currentColor" />
      </>
    ),
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/shashankrai25/',
    icon: (
      <>
        <circle cx="5.5" cy="6.5" r="1.5" fill="currentColor" />
        <rect x="4" y="9" width="3" height="11" rx="1.2" fill="currentColor" />
        <path
          d="M10 9h3v1.6c.6-1 1.6-1.8 3-1.8 2.4 0 4 1.6 4 4.2V20h-3v-6.4c0-1.6-.6-2.6-2-2.6-1.4 0-2.2.9-2.5 1.8-.1.3-.1.7-.1 1.1V20h-3V9z"
          fill="currentColor"
        />
      </>
    ),
  },
]

function SocialLinks() {
  return (
    <nav className="social-links" aria-label="Social links">
      {SOCIAL_LINKS.map((link) => (
        <a
          className="social-link"
          key={link.id}
          href={link.href}
          target="_blank"
          rel="noreferrer"
        >
          <svg className="social-icon" viewBox="0 0 24 24" aria-hidden="true">
            {link.icon}
          </svg>
          <span>{link.label}</span>
        </a>
      ))}
    </nav>
  )
}

export default SocialLinks
